/**
 * Synchronous guard against re-presenting a task the participant just
 * completed. The tasks-collection listener feeding the schedule join can lag
 * the completion write, so right after finishing a task its joined progress
 * may still read 'in-progress' — enough for auto-present to navigate back
 * into the finished questionnaire. `redirectOrNavigateAfterCompletion` marks
 * the task; auto-present holds the landing instead of presenting a marked
 * task and clears the mark once the join reports it done.
 */
type JustCompletedTask = { participationId: string; activityName: string };

let justCompletedTask: JustCompletedTask | null = null;

export const markTaskJustCompleted = (task: JustCompletedTask): void => {
  justCompletedTask = task;
};

export const isTaskJustCompleted = (
  participationId: string,
  activityName: string
): boolean =>
  justCompletedTask?.participationId === participationId &&
  justCompletedTask.activityName === activityName;

export const clearJustCompletedTask = (): void => {
  justCompletedTask = null;
};
